import React from "react";
import { Box, Text } from "@chakra-ui/react";
import _ from "lodash";

interface ProjectNotesProps {
  selectedProject: any;
}

export const ProjectNotes: React.FC<ProjectNotesProps> = ({ selectedProject }) => {
  // Current checkout saves customer comments to order_notes; older checkout
  // used project_description. Show whichever one has content.
  const notes =
    selectedProject?.order?.project_description ||
    selectedProject?.order?.order_notes;

  if (_.isEmpty(notes)) {
    return null;
  }

  return (
    <Box mt="30px">
      <Text
        fontWeight="400"
        fontSize="12px"
        lineHeight="24px"
        color="#8E8C8C"
      >
        Notes
      </Text>
      <Text
        marginTop="5px"
        fontWeight="400"
        fontSize="13px"
        lineHeight="135%"
        color="#000"
        textTransform="capitalize"
        padding="10px"
        backgroundColor="#F1F1F1"
        borderRadius="5px"
      >
        {notes}
      </Text>
    </Box>
  );
};
